export const validators = {
  required: (v) => (v !== undefined && v !== null && String(v).trim() !== '') ? '' : 'This field is required.',
  email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim()) ? '' : 'Enter a valid email address.',
  minLen: (min) => (v) => String(v).trim().length >= min ? '' : `Minimum ${min} characters required.`,
  maxLen: (max) => (v) => String(v).trim().length <= max ? '' : `Maximum ${max} characters allowed.`,
  phone: (v) => /^\d{7,15}$/.test(String(v).replace(/\s/g, '')) ? '' : 'Enter a valid phone number.',
  numeric: (v) => /^\d+(\.\d+)?$/.test(String(v)) ? '' : 'Must be a number.',
  positiveNum: (v) => parseFloat(v) > 0 ? '' : 'Must be greater than zero.',
  url: (v) => !v || /^https?:\/\/.+/.test(v) ? '' : 'Enter a valid URL (https://...).',
  otp: (v) => /^\d{6}$/.test(String(v)) ? '' : 'Enter the 6-digit code.',
  password: (v) => String(v).length >= 8 ? '' : 'Password must be at least 8 characters.',
  date: (v) => !isNaN(Date.parse(v)) ? '' : 'Enter a valid date.',
  time: (v) => /^\d{2}:\d{2}$/.test(v) ? '' : 'Enter a valid time (HH:MM).',
};

/**
 * Validate a form's fields against a rules map
 * @param {object} values - form field values
 * @param {object} rules  - { fieldName: [fn, fn, ...] }
 * @returns {object} errors map (empty string means no error)
 */
export const validate = (values, rules) => {
  const errors = {};
  for (const [field, fns] of Object.entries(rules)) {
    for (const fn of fns) {
      const msg = fn(values[field]);
      if (msg) { errors[field] = msg; break; }
    }
  }
  return errors;
};

export const hasErrors = (errors) => Object.values(errors).some(Boolean);

export const countryCodes = [
  { code: '+233', country: 'Ghana', flag: '🇬🇭' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪' },
  { code: '+27',  country: 'South Africa', flag: '🇿🇦' },
  { code: '+44',  country: 'United Kingdom', flag: '🇬🇧' },
  { code: '+1',   country: 'United States', flag: '🇺🇸' },
  { code: '+49',  country: 'Germany', flag: '🇩🇪' },
  { code: '+33',  country: 'France', flag: '🇫🇷' },
  { code: '+91',  country: 'India', flag: '🇮🇳' },
  { code: '+971', country: 'UAE', flag: '🇦🇪' },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬' },
  { code: '+250', country: 'Rwanda', flag: '🇷🇼' },
  { code: '+225', country: "Côte d'Ivoire", flag: '🇨🇮' },
  { code: '+237', country: 'Cameroon', flag: '🇨🇲' },
  { code: '+212', country: 'Morocco', flag: '🇲🇦' },
  { code: '+20',  country: 'Egypt', flag: '🇪🇬' },
  { code: '+55',  country: 'Brazil', flag: '🇧🇷' },
  { code: '+61',  country: 'Australia', flag: '🇦🇺' },
  { code: '+81',  country: 'Japan', flag: '🇯🇵' },
];

export const selectOptions = {
  roles: ['Student', 'Professional', 'Academic/Researcher', 'Entrepreneur', 'Manager/Executive', 'Consultant', 'Government/Public Sector', 'Other'],
  industries: ['Information Technology', 'Finance/Banking', 'Healthcare', 'Education', 'Agriculture', 'Government', 'Manufacturing', 'Media/Communications', 'NGO/Non-profit', 'Retail/Commerce', 'Energy/Utilities', 'Other'],
  occupations: ['Software Developer', 'Data Scientist/Analyst', 'AI/ML Engineer', 'Project Manager', 'Business Analyst', 'Lecturer/Researcher', 'Student', 'CEO/Founder', 'Product Manager', 'Consultant', 'Other'],
  aiExperienceLevels: ['No experience (complete beginner)', 'Beginner (aware, limited hands-on)', 'Intermediate (regular user/practitioner)', 'Advanced (builds AI-powered solutions)', 'Expert (researcher/developer)'],
  heardAboutUs: ['Social Media (Facebook, Twitter, Instagram)', 'LinkedIn', 'Email Newsletter', 'Friend or Colleague', 'Google/Web Search', 'Event/Conference', 'Blog/Article', 'Other'],
};
